export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628] via-[#1a2942] to-[#2d4263]"></div>
      
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-32">
        <div className="mb-32">
          <h1 className="text-7xl font-bold text-white leading-tight mb-4" style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.02em' }}>
            Modern iOS Applications
          </h1>
          <h1 className="text-7xl font-bold text-white leading-tight mb-4" style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.02em' }}>
            For Enhanced Security
          </h1>
          <h1 className="text-7xl font-bold text-white leading-tight" style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.02em' }}>
            And User Experience
          </h1>
        </div>

        <div className="grid grid-cols-2 gap-32 max-w-6xl">
          <div className="text-white/90 text-lg leading-relaxed">
            Specialized in VPN and Cleaner solutions that protect your digital life while optimizing device performance
          </div>
          <div className="text-white/90 text-lg leading-relaxed -mt-12">
            Trusted by users worldwide for reliable iOS applications
          </div>
        </div>
      </div>
    </section>
  );
}
